var React = require('react');
var CategoriesTable = require('CategoriesTable');
// var laravelApi = require('laravelApi');
var axios = require('axios');


var ReadCategoriesComponent = React.createClass({
    getInitialState: function() {
        return {
            categories: []
        };
    },

    componentDidMount: function() {
        
        var that = this;
        var TOKEN = localStorage.getItem('id_token');
        this.serverRequest = axios.get('/api/v1/categories',{ headers: {
            'Authorization': 'Bearer ' + TOKEN
        }})
          .then(function (response) {
            that.setState({
                categories: response.data
            });
            

          })
          .catch(function (error) {
            console.log(error)
;          });

    },

    componentWillUnmount: function() {

    },

    render: function() {
        var filteredCategories = this.state.categories;
        $('.page-header h1').text('Read categories');

        return (
            <div className="row text-center">
            <h1 className="text-left">Choose categories</h1>

 
                <CategoriesTable
            categories={filteredCategories}  />
            </div>
            );
    }
});


module.exports = ReadCategoriesComponent;


// WEBPACK FOOTER //
// ./react/app/components/Categories.jsx